import {Identifiable} from 'src/app/models/Identifiable';

export interface Capability extends Identifiable {
  description: any;
  selected?: boolean;
  required?: CapabilityType;
  name: string;
  displayName: string;
  version: string;
  disabled?: boolean;
  secretSpec: any;
  nested?: any;
  nestedObj?: any;
}

export enum CapabilityType {
  OPTIONAL = 'optional',
  MANDATORY = 'mandatory'
}

export interface ComponentIdentifier {
  name: string;
  version: string;
}

export interface CapabilitiesGroup {
  name: string;
  capabilities: Capability[];
}
